module.exports = __webpack_public_path__ + "img/Chinese-Taipei.31ef7a98.png";